import { render, staticRenderFns } from "./add-external-activator-form.vue?vue&type=template&id=0615bdc8"
import script from "./add-external-activator-form.vue?vue&type=script&lang=js"
export * from "./add-external-activator-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports